import {useSearchParams} from 'react-router'
import {userSelectors} from '../../../store/user/userSelectors'
import {PerPageOneHundred} from '../../../constants/perPageConstants'
import {useCallback, useLayoutEffect, useState} from 'react'
import {cx} from '../../../utils/classNameUtil'
import {dialogApi} from '../../../api/dialogApi'
import {DialogList} from './DialogList/DialogList'
import {CreateDialogModal} from './CreateDialogModal/CreateDialogModal'
import {WuButton, WuIcon, WuPagination} from '@npm-questionpro/wick-ui-lib'
import {CONVERSATIONS_HELPFILE} from '../../../constants/helpFileLinksConstants'
import styles from './DialogsWrapper.module.scss'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {GLOBAL} from '../../../Translation/English/global'
import {DIALOG} from '../../../Translation/English/dialog'

export const DialogsWrapper: React.FC = () => {
  const selectedWorkforce = userSelectors.useSelectedWorkforce()
  const workforceId = String(selectedWorkforce?.workforceID ?? '')
  const wt = useWt()
  const [searchParams, setSearchParams] = useSearchParams()
  const [page, setPage] = useState(1)

  const viewParam = searchParams.get('view')
  const isActiveTab = viewParam !== 'closed'

  const [showCreateDialogModal, setShowCreateDialogModal] =
    useState<boolean>(false)

  const {data, isLoading} = dialogApi.useDialogs(
    !isActiveTab,
    workforceId,
    page,
  )
  const dialogList = data?.dialogs ?? []
  const dialogCount = data?.total ?? 0

  useLayoutEffect(() => {
    if (!searchParams.get('view')) {
      searchParams.set('view', 'active')
      setSearchParams(searchParams)
    }
  }, [searchParams, setSearchParams])

  const changePage = useCallback((newPage: number) => {
    setPage(newPage + 1)
  }, [])

  const changeTab = useCallback(() => {
    const newTab = isActiveTab ? 'closed' : 'active'
    searchParams.set('view', newTab)
    setSearchParams(searchParams)
    setPage(1)
  }, [isActiveTab, searchParams, setSearchParams])

  const closeModal = (): void => {
    setShowCreateDialogModal(false)
  }

  return (
    <div className={styles.dialogsWrapper}>
      <div className={styles.title}>
        <div>{wt(GLOBAL.conversations)}</div>
        <a href={CONVERSATIONS_HELPFILE} target="_blank" rel="noreferrer">
          <WuIcon icon="wm-help" className={styles.helpIcon} />
        </a>
      </div>
      <WuButton
        onClick={() => setShowCreateDialogModal(true)}
        id={'create-dialog'}
        className={styles.createBtn}
      >
        <WuIcon icon="wm-add" className={styles.plusIcon} />
        {wt(DIALOG.newConversation)}
      </WuButton>
      <div className={styles.section}>
        <div className={styles.tabs}>
          <div
            className={cx(styles.tab, isActiveTab && styles.tabOpen)}
            onClick={changeTab}
          >
            {wt(GLOBAL.active)}
          </div>
          <div
            className={cx(styles.tab, !isActiveTab && styles.tabOpen)}
            onClick={changeTab}
            data-testid="dialogs-archive-tab"
          >
            {wt(GLOBAL.closed)}
          </div>
        </div>
        {dialogCount > PerPageOneHundred && (
          <WuPagination
            initialPage={0}
            initialPageSize={PerPageOneHundred}
            totalRows={dialogCount}
            onPageChange={changePage}
          />
        )}
      </div>
      {!isLoading && (
        <DialogList
          dialogList={dialogList}
          isLoading={isLoading}
          isArchiveTab={!isActiveTab}
          onRefresh={() => setPage(1)}
        />
      )}
      {showCreateDialogModal && (
        <CreateDialogModal
          showModal={showCreateDialogModal}
          closeModal={closeModal}
        />
      )}
    </div>
  )
}
